import { FormGroup } from "../../../components/form";
import * as yup from "yup";
import { Role } from "../../enums/Role";
import { AppealOutcome } from "../../enums/AppealOutcome";

export const appealOutcomeForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Appeal Outcome",
    },
    {
      type: "field",
      key: "appealAssessedBy",
      label: "Appeal Assessed By",
      fieldType: "dropdown",
      props: {
        placeholder: "Select an Assessor",
      },
      expressionProps: {
        options: (context) => context.options,
      },
      validation: yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "outcome",
      label: "Appeal Outcome",
      validation: yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: AppealOutcome.PreviousOutcomeUpheld,
            value: AppealOutcome.PreviousOutcomeUpheld,
          },
          {
            label: AppealOutcome.OutcomeUpdated,
            value: AppealOutcome.OutcomeUpdated,
          },
          {
            label: AppealOutcome.ReferredToDeForDecision,
            value: AppealOutcome.ReferredToDeForDecision,
          },
          {
            label: AppealOutcome.Other,
            value: AppealOutcome.Other,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "input",
      key: "otherOutcomeSpecify",
      label: "Please Specify",
      validation: yup.string().trim().required("A response is required"),
      hideExpression: (formContext: any, values: any) => {
        return values?.outcome !== "Other (please specify)";
      },
      warn: "Specify the appeal outcome",
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "additionalComments",
      label: "Additional Comments",
      warn: "Provide any relevant information relating to how the appeal was reviewed and details of any correspondence with DE to finalise the outcome of the appeal",
    },
    {
      type: "field",
      key: "PrevApplicationId",
      fieldType: "button",
      label: "Open Original Application",
      props: {
        className: "form-button open-app-btn",
        disabled: false,
      },
      expressionProps: {
        onClick: (context) => () => {
          if (context.userRole === Role.department) {
            window.open(`/department/applications/${context.prevApplicationId}`, "_blank");
          } else if (context.userRole === Role.kindergarten) {
            window.open(`/kindergarten/submittedApplications/${context.prevApplicationId}`, "_blank");
          } else {
            window.open(`/applications/ApplicationBaseCurrent/${context.prevApplicationId}`, "_blank");
          }
        },
      },
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Click on the button to view the application to which this appeal relates",
    },
  ],
};
